import { httpClient } from "../http-client/base-client";
import {
  ApiPutUser,
  ApiUser,
  ApiUserPhone,
  ApiUserPhoneCheck,
} from "../types/user/api-types";

export const userResource = {
  async getUserInfo(): Promise<ApiUser> {
    const user = await httpClient.get<ApiUser>("user");
    return user;
  },
  async patchUser(user: ApiPutUser): Promise<ApiUser> {
    const product = await httpClient.patch<ApiUser>("user", user);
    return product;
  },

  async postPhone(phone: ApiUserPhone): Promise<void> {
    await httpClient.post("user/phone", phone);
  },

  async postPhoneCheck(phone: ApiUserPhoneCheck): Promise<void> {
    await httpClient.post("user/phone/check", phone);
  },

  async deleteUser() {
    await httpClient.delete("user");
  },
};
